import { Component, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-targeting-form-add',
  template: `<a href="" (click)="add.emit($event)">Add Row</a>`,
  styles:   [`:host {
                margin-top: 10px;
                font-size: 12px;
              }
            `]
})
export class TargetingFormAddComponent {
  @Output() add = new EventEmitter();
}
